import React from 'react';
export function SolutionSection() {
  const tomos = [{
    label: 'Sub-10',
    color: '#1565C0'
  }, {
    label: 'Junior',
    color: '#2E7D32'
  }, {
    label: 'Adultos',
    color: '#E65100'
  }, {
    label: 'Avanzado',
    color: '#6A1B9A'
  }, {
    label: 'Táctica',
    color: '#37474F'
  }, {
    label: 'Físico',
    color: '#BF360C'
  }];
  return <section className="w-full bg-black py-12 px-4" data-id="element-254">
      <div className="max-w-4xl mx-auto text-center" data-id="element-255">
        <h2 className="text-3xl sm:text-5xl font-black text-white mb-2" data-id="element-256">
          🎾 PROFEPACK™
        </h2>
        <p className="text-[#00B4D8] text-sm sm:text-base font-bold mb-6" data-id="element-257">
          Sistema N°1 para Profesores de Tenis en Argentina
        </p>
        <p className="text-white text-base sm:text-lg max-w-xl mx-auto mb-8 leading-relaxed" data-id="element-258">
          <strong data-id="element-259">6 Tomos + 6 Bonos</strong> · +540 páginas · 48 semanas modelo
          <br className="hidden sm:block" data-id="element-260" />
          Técnica · Táctica · Drills · Gestión · Negocio — listo para usar hoy.
        </p>

        {/* Mockup visual */}
        <div className="relative mx-auto mb-10 max-w-md sm:max-w-2xl" data-id="element-261">
          <div className="grid grid-cols-6 gap-2" data-id="element-262">
            {tomos.map((tomo, i) => <div key={i} className="aspect-[3/4] rounded-lg shadow-2xl flex items-end justify-center pb-2" style={{
            backgroundColor: tomo.color,
            border: '2px solid #00B4D8'
          }} data-id="element-263">
                <span className="text-white text-[10px] sm:text-xs font-bold" style={{
              textShadow: '0 1px 3px rgba(0,0,0,0.8)'
            }} data-id="element-264">
                  {tomo.label}
                </span>
              </div>)}
          </div>
          <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-[#00B4D8] text-black font-black text-xs px-4 py-1 rounded-full whitespace-nowrap" data-id="element-265">
            6 TOMOS COMPLETOS
          </div>
        </div>

        {/* Pills */}
        <div className="flex flex-wrap items-center justify-center gap-2 mt-8" data-id="element-266">
          {['Por nivel y categoría argentina', '48 semanas con objetivo y cierre', 'Evaluación + fichas de progreso', 'Drills · Planificación · Negocio'].map(text => <span key={text} className="bg-[#00B4D8]/10 border border-[#00B4D8]/40 text-[#00B4D8] text-xs sm:text-sm font-semibold px-3 py-1.5 rounded-full" data-id="element-267">
              ✅ {text}
            </span>)}
        </div>
      </div>
    </section>;
}